import { useCallback } from 'react';
import { currentLanguage, SPEECH_LANG } from '@/i18n';
import { toLatin, useSpeechRecognition } from '../dictation';

/**
 * Dictation into one field, in the UI language. `onText` gets each finished
 * phrase (Cyrillic from the speech engine already in Latin script).
 */
export function useFieldDictation(onText: (text: string) => void) {
  const speech = useSpeechRecognition({
    lang: SPEECH_LANG[currentLanguage()],
    onFinal: (text) => onText(toLatin(text.trim())),
  });
  const { listening, start, stop } = speech;
  const toggle = useCallback(() => (listening ? stop() : start()), [listening, start, stop]);
  return { ...speech, interim: toLatin(speech.interim), toggle };
}
